import { render, staticRenderFns } from "./route_management.vue?vue&type=template&id=63d1156c"
import script from "./route_management.vue?vue&type=script&lang=js"
export * from "./route_management.vue?vue&type=script&lang=js"
import style0 from "./route_management.vue?vue&type=style&index=0&id=63d1156c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports